import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'

export const useRemoveInventoryObjectFile = () => {
  const http = useHttp()
  const { addError } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) =>
      http.del(`/inventory/objects/passport/${data.id}/files`, { file: data.file }),
  })

  const remove = async (data: any) => {
    try {
      await mutation.mutateAsync(data)
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
      throw error
    }
  }

  return {
    ...mutation,

    remove,
  }
}
